<template>
  <div class="login-page">
    <!-- Left Panel - Branding -->
    <div class="brand-panel">
      <div class="brand-content">
        <div class="logo-section">
          <div class="logo-icon">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="40" height="40" rx="8" fill="white" fill-opacity="0.15"/>
              <path d="M20 8L32 14V26L20 32L8 26V14L20 8Z" stroke="white" stroke-width="2" fill="none"/>
              <circle cx="20" cy="20" r="6" fill="white" fill-opacity="0.3"/>
            </svg>
          </div>
          <h1 class="brand-name">AutoBank</h1>
        </div>

        <div class="brand-message">
          <h2>Безопасные платежи для вашего бизнеса</h2>
          <p>Управляйте финансами с уверенностью. Быстро, надежно, прозрачно.</p>
        </div>

        <div class="trust-indicators">
          <div class="trust-item">
            <div class="trust-icon">
              <i class="ni ni-lock-circle-open"></i>
            </div>
            <span>256-bit шифрование</span>
          </div>
          <div class="trust-item">
            <div class="trust-icon">
              <i class="ni ni-check-bold"></i>
            </div>
            <span>PCI DSS сертификат</span>
          </div>
          <div class="trust-item">
            <div class="trust-icon">
              <i class="ni ni-time-alarm"></i>
            </div>
            <span>24/7 поддержка</span>
          </div>
        </div>
      </div>

      <!-- Decorative elements -->
      <div class="decoration-circle circle-1"></div>
      <div class="decoration-circle circle-2"></div>
      <div class="decoration-circle circle-3"></div>
    </div>

    <!-- Right Panel - Login Form -->
    <div class="form-panel">
      <div class="form-container">
        <div class="form-header">
          <h3>Добро пожаловать</h3>
          <p>Введите данные для входа в систему</p>
        </div>

        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)" class="login-form">
            <div class="form-group-custom">
              <label for="email">Email</label>
              <div class="input-wrapper">
                <i class="ni ni-email-83 input-icon"></i>
                <input
                  id="email"
                  type="email"
                  class="custom-input"
                  placeholder="name@company.com"
                  v-model="model.email"
                  required
                />
              </div>
            </div>

            <div class="form-group-custom">
              <label for="password">Пароль</label>
              <div class="input-wrapper">
                <i class="ni ni-lock-circle-open input-icon"></i>
                <input
                  id="password"
                  type="password"
                  class="custom-input"
                  placeholder="Введите пароль"
                  v-model="model.password"
                  required
                />
              </div>
            </div>

            <div class="form-options">
              <label class="custom-checkbox">
                <input type="checkbox" v-model="model.rememberMe" />
                <span class="checkmark"></span>
                <span class="checkbox-label">Запомнить меня</span>
              </label>
              <a href="#" class="forgot-link">Забыли пароль?</a>
            </div>

            <button type="submit" class="submit-btn" :disabled="loading">
              <span v-if="!loading">Войти в систему</span>
              <span v-else class="loading-state">
                <span class="spinner"></span>
                Вход...
              </span>
            </button>
          </b-form>
        </validation-observer>

        <div class="form-footer">
          <p>Нет аккаунта? <router-link to="/register" class="register-link">Создать аккаунт</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios'

export default {
  data() {
    return {
      loading: false,
      model: {
        email: '',
        password: '',
        rememberMe: false
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  watch: {
    currentUser() {
      this.$router.push({name: 'dashboard'});
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        const response = await axios.post("login", {
          email: this.model.email,
          password: this.model.password,
        });

        localStorage.setItem("token", response.data.token);
        const token = localStorage.getItem('token');
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        this.$store.dispatch("fetchUser");
      } catch (error) {
        console.error('Login failed:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
}

/* Left Panel - Branding */
.brand-panel {
  flex: 1;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0c4a6e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  position: relative;
  overflow: hidden;
}

.brand-content {
  position: relative;
  z-index: 2;
  max-width: 480px;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 48px;
}

.logo-icon {
  width: 48px;
  height: 48px;
}

.logo-icon svg {
  width: 100%;
  height: 100%;
}

.brand-name {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
  margin: 0;
}

.brand-message h2 {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}

.brand-message p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 48px;
}

.trust-indicators {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.trust-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

.trust-icon {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trust-icon i {
  font-size: 16px;
  color: #38bdf8;
}

/* Decorative circles */
.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.15) 0%, rgba(59, 130, 246, 0.05) 100%);
}

.circle-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  right: -100px;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  left: -100px;
}

.circle-3 {
  width: 200px;
  height: 200px;
  bottom: 20%;
  right: 10%;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%);
}

/* Right Panel - Form */
.form-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  background: #fff;
}

.form-container {
  width: 100%;
  max-width: 400px;
}

.form-header {
  margin-bottom: 36px;
}

.form-header h3 {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.form-header p {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

/* Custom Form Styles */
.form-group-custom {
  margin-bottom: 24px;
}

.form-group-custom label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 18px;
  transition: color 0.2s ease;
}

.custom-input {
  width: 100%;
  padding: 14px 16px 14px 48px;
  font-size: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  color: #0f172a;
  transition: all 0.2s ease;
  outline: none;
}

.custom-input::placeholder {
  color: #94a3b8;
}

.custom-input:hover {
  border-color: #cbd5e1;
}

.custom-input:focus {
  border-color: #3b82f6;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.custom-input:focus + .input-icon,
.input-wrapper:focus-within .input-icon {
  color: #3b82f6;
}

/* Form Options */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.custom-checkbox:hover .checkmark {
  border-color: #3b82f6;
}

.custom-checkbox input:checked ~ .checkmark {
  background: #3b82f6;
  border-color: #3b82f6;
}

.custom-checkbox input:checked ~ .checkmark::after {
  content: '';
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin-bottom: 2px;
}

.checkbox-label {
  font-size: 14px;
  color: #475569;
}

.forgot-link {
  font-size: 14px;
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.forgot-link:hover {
  color: #2563eb;
}

/* Submit Button */
.submit-btn {
  width: 100%;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.35);
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.45);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Form Footer */
.form-footer {
  margin-top: 32px;
  text-align: center;
}

.form-footer p {
  font-size: 15px;
  color: #64748b;
  margin: 0;
}

.register-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.register-link:hover {
  color: #2563eb;
}

/* Responsive */
@media (max-width: 1024px) {
  .brand-panel {
    display: none;
  }

  .form-panel {
    padding: 40px 24px;
  }

  .login-page {
    background: #fff;
  }
}

@media (max-width: 480px) {
  .form-container {
    max-width: 100%;
  }

  .form-header h3 {
    font-size: 24px;
  }

  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
</style>
